module.exports = __webpack_public_path__ + "static/media/Drew.dc441ba8.webp";